
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { types } from '../../api_types';
import T from '../../lang';
import * as time from '../../time';
import * as ui from '../../ui';
import common_Paginator from '../common/Paginator.vue';
import common_Typeahead from '../common/Typeahead.vue';
import CountryFlag from '../CountryFlag.vue';
import user_Username from '../user/Username.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheckSquare,
  faExchangeAlt,
  faQuestionCircle,
  faTimes,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faCheckSquare, faExchangeAlt, faQuestionCircle, faTimes, faUser);

import { getBlogUrl } from '../../urlHelper';

// Import Bootstrap and BootstrapVue CSS files (order is important: base before overrides)
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
// Import Only Required Plugins
import { ButtonPlugin, PopoverPlugin } from 'bootstrap-vue';
Vue.use(ButtonPlugin);
Vue.use(PopoverPlugin);
interface Rank {
  country: string;
  classname?: string;
  username: string;
  name?: string;
  score: number;
  problems_solved: number;
}

@Component({
  components: {
    FontAwesomeIcon,
    'omegaup-common-typeahead': common_Typeahead,
    'omegaup-countryflag': CountryFlag,
    'omegaup-user-username': user_Username,
    'omegaup-common-paginator': common_Paginator,
  },
})
export default class UserRank extends Vue {
  @Prop() page!: number;
  @Prop() length!: number;
  @Prop({ default: false }) isIndex!: boolean;
  @Prop() isLogged!: boolean;
  @Prop({ default: () => ({}) }) availableFilters!: { [key: string]: string };
  @Prop({ default: null }) filter!: string | null;
  @Prop() ranking!: Rank[];
  @Prop() lastUpdated!: Date;
  @Prop() resultTotal!: number;
  @Prop() pagerItems!: types.PageItem[];
  @Prop() searchResultUsers!: types.ListItem[];
  @Prop({ default: '' }) currentUsername!: string;

  T = T;
  ui = ui;
  searchedUsername: null | types.ListItem = null;
  showPopover: boolean = false;
  currentFilter = this.filter;
  isSelectionMode: boolean = false;
  selectedUsers: string[] = [];

  get UserRankingFeatureGuideURL(): string {
    // Use the key defined in blog.json
    return getBlogUrl('UserRankingFeatureGuideURL');
  }

  get lastUpdatedText(): null | string {
    if (!this.lastUpdated) {
      return null;
    }
    return ui.formatString(T.userRankLastUpdated, {
      datetime: time.formatDateLocalHHMM(this.lastUpdated),
    });
  }
  onSubmit(): void {
    if (!this.searchedUsername) return;
    window.location.href = `/profile/${encodeURIComponent(
      this.searchedUsername.key,
    )}`;
  }

  @Watch('currentFilter')
  onFilterChange(newFilter: string): void {
    // change url parameters with jquery
    // https://samaxes.com/2011/09/change-url-parameters-with-jquery/
    let queryParameters: { [key: string]: string } = {};
    const re = /([^&=]+)=([^&]*)/g;
    const queryString = location.search.substring(1);
    let m: string[] | null = null;
    while ((m = re.exec(queryString))) {
      queryParameters[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
    }
    if (newFilter !== '') {
      queryParameters['filter'] = newFilter;
      // When a filter is selected, the parameter 'page' must be reset.
      delete queryParameters['page'];
    } else {
      delete queryParameters['filter'];
    }
    window.location.search = ui.buildURLQuery(queryParameters);
  }

  toggleUserSelection(username: string): void {
    const index = this.selectedUsers.indexOf(username);
    if (index > -1) {
      this.selectedUsers.splice(index, 1);
    } else if (this.selectedUsers.length < 2) {
      this.selectedUsers.push(username);
    }
  }

  isUserSelected(username: string): boolean {
    return this.selectedUsers.includes(username);
  }

  cancelSelection(): void {
    this.isSelectionMode = false;
    this.selectedUsers = [];
  }

  compareSelectedUsers(): void {
    if (this.selectedUsers.length === 2) {
      window.location.href = `/rank/compare/?username1=${encodeURIComponent(
        this.selectedUsers[0],
      )}&username2=${encodeURIComponent(this.selectedUsers[1])}`;
    }
  }

  compareVsMe(): void {
    if (this.selectedUsers.length === 1 && this.currentUsername) {
      window.location.href = `/rank/compare/?username1=${encodeURIComponent(
        this.selectedUsers[0],
      )}&username2=${encodeURIComponent(this.currentUsername)}`;
    }
  }

  get nextPageFilter(): string {
    if (this.currentFilter)
      return `/rank?page=${this.page + 1}&filter=${encodeURIComponent(
        this.currentFilter,
      )}`;
    else return `/rank?page=${this.page + 1}`;
  }

  get prevPageFilter(): string {
    if (this.currentFilter)
      return `/rank?page=${this.page - 1}&filter=${encodeURIComponent(
        this.currentFilter,
      )}`;
    else return `/rank?page=${this.page - 1}`;
  }
}
